import React from "react";

export default function Loading() {
	return (
		<div className="columns is-vcentered" style={{ height: "50vh" }}>
			<div className="column has-text-centered">
				<span className="icon is-large has-text-info">
					<i
						className="fas fa-circle-notch fa-spin fa-3x"
						aria-hidden="true"
					></i>
				</span>
			</div>
		</div>
	);
}
